import posthog from 'posthog-js'

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined

export function initPosthog() {
  if (!key) return
  posthog.init(key, {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    // Only create person profiles for identified users (logged-in), not anonymous visitors
    person_profiles: 'identified_only',
    // localStorage for distinct_id — no cookies written by PostHog
    persistence: 'localStorage',
    // Disable the cross-subdomain cookie (ph_<token>_us) PostHog sets by default
    cross_subdomain_cookie: false,
    // If any cookie were ever set, restrict to HTTPS only
    secure_cookie: true,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    disable_session_recording: true,
  })
}

export function identifyUser(userId: string) {
  if (!key) return
  posthog.identify(userId)
}

export function resetUser() {
  if (!key) return
  posthog.reset()
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!key) return
  posthog.capture(event, properties)
}
